import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo"}/>
}
